<form [formGroup]="accountingPrinciplesForDeterminingTheResultFg">
  <div class="row">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslagen voor de bepaling van het resultaat</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.accountingPrinciplesForDeterminingTheResultFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(1)">
        {{ this.accountingPrinciplesForDeterminingTheResultFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="revenueRecognitionPolicyFg">
  <div class="row">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van omzetverantwoording</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.revenueRecognitionPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(2)">
        {{ this.revenueRecognitionPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="grossMarginPolicyFg">
  <div class="row">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van bruto-bedrijfsresultaat</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.grossMarginPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(3)">
        {{ this.grossMarginPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="netRevenuePolicyFg">
  <div class="row" *ngIf="this.heeftNettoOmzet">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van netto-omzet</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.netRevenuePolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(40)">
        {{ this.netRevenuePolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="revenuesFromSaleOfGoodsPolicyFg">
  <div class="row" *ngIf="this.heeftNettoOmzet">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van opbrengsten uit de verkoop van goederen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.revenuesFromSaleOfGoodsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(41)">
        {{ this.revenuesFromSaleOfGoodsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="revenuesFromProvidingServicesPolicyFg">
  <div class="row" *ngIf="this.heeftNettoOmzet">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van opbrengsten uit het verlenen van diensten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.revenuesFromProvidingServicesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(42)">
        {{ this.revenuesFromProvidingServicesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>

<form [formGroup]="changesInventoriesWorkInProgressPolicyFg">
  <div class="row" *ngIf="this.heeftWaardeveranderingenVoorraad">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van wijziging in voorraden gereed product en onderhanden werk</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.changesInventoriesWorkInProgressPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(43)">
        {{ this.changesInventoriesWorkInProgressPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="projectIncomePolicyFg">
  <div class="row">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van projectopbrengsten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.projectIncomePolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(44)">
        {{ this.projectIncomePolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="capitalisedProductionCostsPolicyFg">
  <div class="row" *ngIf="this.heeftGeactiveerdeProductieEigenBedrijf">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van geactiveerde productie ten behoeve van het eigen bedrijf</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.capitalisedProductionCostsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(45)">
        {{ this.capitalisedProductionCostsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="privateUseOwnBusinessCurrentPolicyFg">
  <div class="row" *ngIf="!this.isRechtspersoon && this.heeftPriveGebruikEigenBedrijf">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van privé gebruik eigen bedrijf</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.privateUseOwnBusinessCurrentPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(46)">
        {{ this.privateUseOwnBusinessCurrentPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="exploitationSubsidiesPolicyFg">
  <div class="row" *ngIf="this.isRechtspersoon && this.heeftExploitatiesubsidies">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van exploitatiesubsidies</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.exploitationSubsidiesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(47)">
        {{ this.exploitationSubsidiesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="operatingIncomeOtherPolicyFg">
  <div class="row" *ngIf="this.heeftOverigeBedrijfsopbrengsten">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van overige bedrijfsopbrengsten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.operatingIncomeOtherPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(48)">
        {{ this.operatingIncomeOtherPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="costsRawMaterialsConsumablesPolicyFg">
  <div class="row" *ngIf="this.heeftKostenGrondEnHulpstoffen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van kosten van grond- en hulpstoffen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.costsRawMaterialsConsumablesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(50)">
        {{ this.costsRawMaterialsConsumablesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="costsOutsourcedWorkOtherExternalExpensesPolicyFg">
  <div class="row" *ngIf="this.heeftKostenUitbesteedWerk">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van kosten uitbesteed werk en andere externe kosten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.costsOutsourcedWorkOtherExternalExpensesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(51)">
        {{ this.costsOutsourcedWorkOtherExternalExpensesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>

<form [formGroup]="employeeBenefitsExpensesPolicyFg">
  <div class="row" *ngIf="this.heeftLastenUitHoofdePersoneelsbeloningen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van lasten uit hoofde van personeelsbeloningen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.employeeBenefitsExpensesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(70)">
        {{ this.employeeBenefitsExpensesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="wagesSalariesPolicyFg">
  <div class="row" *ngIf="this.heeftLastenUitHoofdePersoneelsbeloningen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van lonen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.wagesSalariesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(71)">
        {{ this.wagesSalariesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="pensionCostsPolicyFg">
  <div class="row" *ngIf="this.heeftLastenUitHoofdePersoneelsbeloningen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van pensioenlasten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.pensionCostsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(72)">
        {{ this.pensionCostsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>

<form [formGroup]="depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicyFg">
  <div class="row" *ngIf="this.heeftAfschrijvingenIvaMva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van afschrijvingen op immateriële en materiële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(80)">
        {{ this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="changesInValueIntangibleAssetsPropertyPlantEquipmentPolicyFg">
  <div class="row" *ngIf="this.heeftWaardeveranderingenIvaMva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van waardeveranderingen van immateriële en materiële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.changesInValueIntangibleAssetsPropertyPlantEquipmentPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(85)">
        {{ this.changesInValueIntangibleAssetsPropertyPlantEquipmentPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="changesValueInvestmentPropertiesPolicyFg">
  <div class="row" *ngIf="this.heeftWaardeveranderingenVastgoedbeleggingen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van wijziging in de reële waarde van vastgoedbeleggingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.changesValueInvestmentPropertiesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(86)">
        {{ this.changesValueInvestmentPropertiesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="impairmentCurrentAssetsPolicyFg">
  <div class="row" *ngIf="this.heeftWaardeverminderingenVlottendeActiva">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van waardeverminderingen van vlottende activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.impairmentCurrentAssetsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(87)">
        {{ this.impairmentCurrentAssetsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="operatingExpensesOtherPolicyFg">
  <div class="row" *ngIf="this.heeftOverigeBedrijfskosten">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van overige bedrijfskosten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.operatingExpensesOtherPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(90)">
        {{ this.operatingExpensesOtherPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="operatingExpensesPolicyFg">
  <div class="row" *ngIf="this.heeftBedrijfslasten">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van bedrijfslasten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.operatingExpensesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(99)">
        {{ this.operatingExpensesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="revaluationReserveReleasePolicyFg">
  <div class="row" *ngIf="this.isRechtspersoon && this.heeftVrijvalUitHerwaarderingsreserve">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van uit herwaarderingsreserve vrijgevallen bedragen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.revaluationReserveReleasePolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(100)">
        {{ this.revaluationReserveReleasePolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="governmentSubsidiesPolicyFg">
  <div class="row">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van overheidssubsidies</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           [disabled]="this.governmentSubsidiesPolicyFg.get('selected')?.getRawValue() === false"
                           icon="{{ this.governmentSubsidiesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(101)">
        {{ this.governmentSubsidiesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
        <ng-container
          *ngIf="this.governmentSubsidiesPolicyFg.get('selected')?.getRawValue() !== null">
          <snelstart-ui-select-form-control formControlName="selected"
                                            [options]="this.optionsJaNee"
                                            class="custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </ng-container>
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="financialIncomeExpensesPolicyFg">
  <div class="row" *ngIf="this.heeftFinancieleBatenLasten">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van financiële baten en lasten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.financialIncomeExpensesPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(110)">
        {{ this.financialIncomeExpensesPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="incomeTaxExpensePolicyFg">
  <div class="row" *ngIf="this.isRechtspersoon && this.heeftBelastingen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van belastingen over de winst of het verlies</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.incomeTaxExpensePolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(120)">
        {{ this.incomeTaxExpensePolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="shareInResultsParticipatingInterestsPolicyFg">
  <div class="row" *ngIf="this.isRechtspersoon && this.heeftResultaatUitDeelnemingen">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van resultaat uit deelnemingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.shareInResultsParticipatingInterestsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(121)">
        {{ this.shareInResultsParticipatingInterestsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>
<form [formGroup]="resultEntityPolicyFg">
  <div class="row" *ngIf="this.isRechtspersoon">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Grondslag van resultaat toekomend aan de rechtspersoon</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.resultEntityPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(122)">
        {{ this.resultEntityPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    <ng-container>
      <div class="col-3">
      </div>
    </ng-container>
  </div>
</form>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.accountingPrinciplesForDeterminingTheResultFg"
                                                                     [policyId]="'accountingPrinciplesForDeterminingTheResult'"
                                                                     [title]="'Grondslagen voor de bepaling van het resultaat'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.revenueRecognitionPolicyFg"
                                                                     [policyId]="'revenueRecognitionPolicy'"
                                                                     [title]="'Grondslag van omzetverantwoording'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.grossMarginPolicyFg"
                                                                     [policyId]="'grossMarginPolicy'"
                                                                     [title]="'Grondslag van bruto-bedrijfsresultaat'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 40">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.netRevenuePolicyFg"
                                                                     [policyId]="'netRevenuePolicy'"
                                                                     [title]="'Grondslag van netto-omzet'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 41">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.revenuesFromSaleOfGoodsPolicyFg"
                                                                     [policyId]="'revenuesFromSaleOfGoodsPolicy'"
                                                                     [title]="'Grondslag van opbrengsten uit de verkoop van goederen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 42">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.revenuesFromProvidingServicesPolicyFg"
                                                                     [policyId]="'revenuesFromProvidingServicesPolicy'"
                                                                     [title]="'Grondslag van opbrengsten uit het verlenen van diensten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>

<div *ngIf="this.index === 43">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.changesInventoriesWorkInProgressPolicyFg"
                                                                     [policyId]="'changesInventoriesWorkInProgressPolicy'"
                                                                     [title]="'Grondslag van wijziging van de voorraad gereed product en onderhanden werk'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 44">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.projectIncomePolicyFg"
                                                                     [policyId]="'projectIncomePolicy'"
                                                                     [title]="'Grondslag van projectopbrengsten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 45">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.capitalisedProductionCostsPolicyFg"
                                                                     [policyId]="'capitalisedProductionCostsPolicy'"
                                                                     [title]="'Grondslag van geactiveerde productie ten behoeve van het eigen bedrijf'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 46">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.privateUseOwnBusinessCurrentPolicyFg"
                                                                     [policyId]="'privateUseOwnBusinessCurrentPolicy'"
                                                                     [title]="'Grondslag van privé gebruik eigen bedrijf'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 47">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.exploitationSubsidiesPolicyFg"
                                                                     [policyId]="'exploitationSubsidiesPolicy'"
                                                                     [title]="'Grondslag van exploitatiesubsidies'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 48">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.operatingIncomeOtherPolicyFg"
                                                                     [policyId]="'operatingIncomeOtherPolicy'"
                                                                     [title]="'Grondslag van overige bedrijfsopbrengsten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 50">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.costsRawMaterialsConsumablesPolicyFg"
                                                                     [policyId]="'costsRawMaterialsConsumablesPolicy'"
                                                                     [title]="'Grondslag van kosten van grond- en hulpstoffen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 51">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.costsOutsourcedWorkOtherExternalExpensesPolicyFg"
                                                                     [policyId]="'costsOutsourcedWorkOtherExternalExpensesPolicy'"
                                                                     [title]="'Grondslag van kosten uitbesteed werk en andere externe kosten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 70">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.employeeBenefitsExpensesPolicyFg"
                                                                     [policyId]="'employeeBenefitsExpensesPolicy'"
                                                                     [title]="'Grondslag van lasten uit hoofde van personeelsbeloningen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 71">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.wagesSalariesPolicyFg"
                                                                     [policyId]="'wagesSalariesPolicy'"
                                                                     [title]="'Grondslag van lonen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 72">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.pensionCostsPolicyFg"
                                                                     [policyId]="'pensionCostsPolicy'"
                                                                     [title]="'Grondslag van pensioenlasten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>

<div *ngIf="this.index === 80">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicyFg"
                                                                     [policyId]="'depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicy'"
                                                                     [title]="'Grondslag van afschrijvingen op immateriële en materiële vaste activa'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 85">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.changesInValueIntangibleAssetsPropertyPlantEquipmentPolicyFg"
                                                                     [policyId]="'changesInValueIntangibleAssetsPropertyPlantEquipmentPolicy'"
                                                                     [title]="'Grondslag van waardeveranderingen van immateriële en materiële vaste activa'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 86">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.changesValueInvestmentPropertiesPolicyFg"
                                                                     [policyId]="'changesValueInvestmentPropertiesPolicy'"
                                                                     [title]="'Grondslag van wijziging in de reële waarde van vastgoedbeleggingen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 87">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.impairmentCurrentAssetsPolicyFg"
                                                                     [policyId]="'impairmentCurrentAssetsPolicy'"
                                                                     [title]="'Grondslag van waardeverminderingen van vlottende activa'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 90">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.operatingExpensesOtherPolicyFg"
                                                                     [policyId]="'operatingExpensesOtherPolicy'"
                                                                     [title]="'Grondslag van overige bedrijfskosten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 99">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.operatingExpensesPolicyFg"
                                                                     [policyId]="'operatingExpensesPolicy'"
                                                                     [title]="'Grondslag van bedrijfslasten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 100">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.revaluationReserveReleasePolicyFg"
                                                                     [policyId]="'revaluationReserveReleasePolicy'"
                                                                     [title]="'Grondslag van uit herwaarderingsreserve vrijgevallen bedragen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 101">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.governmentSubsidiesPolicyFg"
                                                                     [policyId]="'governmentSubsidiesPolicy'"
                                                                     [title]="'Grondslag van overheidssubsidies'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 110">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.financialIncomeExpensesPolicyFg"
                                                                     [policyId]="'financialIncomeExpensesPolicy'"
                                                                     [title]="'Grondslag van financiële baten en lasten'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 120">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.incomeTaxExpensePolicyFg"
                                                                     [policyId]="'incomeTaxExpensePolicy'"
                                                                     [title]="'Grondslag van belastingen over de winst of het verlies'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 121">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.shareInResultsParticipatingInterestsPolicyFg"
                                                                     [policyId]="'shareInResultsParticipatingInterestsPolicy'"
                                                                     [title]="'Grondslag van resultaat uit deelnemingen'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>
<div *ngIf="this.index === 122">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy [(dialogVisible)]="this.dialogVisible"
                                                                     [(input)]="this.resultEntityPolicyFg"
                                                                     [policyId]="'resultEntityPolicy'"
                                                                     [title]="'Grondslag van resultaat toekomend aan de rechtspersoon'"
                                                                     (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy>
</div>

